/*
 * Copyright (c) 2023, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react';
import {useIntl} from 'react-intl';
import PropTypes from 'prop-types';

// Project Components
import LinksList from '@salesforce/retail-react-app/app/components/links-list';
// Components
import {Container, SimpleGrid, Stack, useTheme} from '@salesforce/retail-react-app/app/components/shared/ui';
// Others
import {categoryUrlBuilder} from '@salesforce/retail-react-app/app/utils/url';

const ListMenuContent = ({maxColumns, item, itemsKey, onClose, initialFocusRef}) => {
  const theme = useTheme();
  const {baseStyle} = theme.components.ListMenu;
  const {locale} = useIntl();
  const items = item?.[itemsKey] || [];

  return (
    <Container as={Stack} {...baseStyle.popoverContainer}>
      <SimpleGrid
        justifyContent="left"
        marginInlineStart={{lg: '68px', xl: '96px'}}
        spacing={8}
        gridTemplateColumns={`repeat(${items.length > maxColumns ? maxColumns : items.length
        }, minmax(0, 21%))`}
      >
        {items.map((item, index) => {
          const {id, name} = item;
          const items = item[itemsKey];

          const heading = {
            href: categoryUrlBuilder(item, locale),
            text: name,
            styles: {
              fontSize: 'md',
              marginBottom: 2,
            },
          };

          const links = items ?
            items.map((item) => {
              const {name} = item;

              return {
                href: categoryUrlBuilder(item, locale),
                text: name,
                styles: {
                  fontSize: 'md',
                  paddingTop: 3,
                  paddingBottom: 3,
                },
              };
            }) :
            [];

          return (
            <LinksList
              key={id}
              color="gray.900"
              heading={heading}
              links={links}
              onLinkClick={onClose}
              {...(index === 0 ? {headingLinkRef: initialFocusRef} : {})}
            />
          );
        })}
      </SimpleGrid>
    </Container>
  );
};

ListMenuContent.propTypes = {
  item: PropTypes.object,
  itemsKey: PropTypes.string,
  maxColumns: PropTypes.number,
  onClose: PropTypes.func,
  initialFocusRef: PropTypes.object,
};

export {ListMenuContent};
